import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "İlaçlama hizmetleri",
  heroDescription: "Adana'da haşere ve böceklere karşı profesyonel ilaçlama hizmeti. Ev, apartman, site ve iş yerleri için etkili çözümler.",
  description: "Haşere ve böcek sorunları yaşam alanlarında hijyen ve konforu olumsuz etkileyebilir. Day Temizlik Adana, ev, apartman, site ve iş yerlerinde ihtiyaçlara uygun ilaçlama hizmeti sunar. Profesyonel uygulama, güvenli planlama ve doğru destek vurgusuyla çalışıyoruz.",
  scope: [
    "Ev ilaçlama",
    "Apartman ilaçlama",
    "Site ilaçlama",
    "İş yeri ilaçlama",
    "Haşere ve böceklere karşı uygulama",
    "Periyodik ilaçlama planı",
  ],
  forWho: [
    "Ev sahipleri",
    "Apartman ve site sakinleri",
    "İş yeri sahipleri",
    "Restoran ve gıda işletmeleri",
    "Depo ve depolama alanları",
  ],
  process: [
    "Alanı ve haşere yoğunluğunu değerlendiriyoruz.",
    "İhtiyaca uygun ilaçlama planı hazırlıyoruz.",
    "Profesyonel ekip tarafından uygulama yapıyoruz.",
    "Güvenli bekleme süresi ve havalandırma talimatlarını veriyoruz.",
    "Periyodik takvim oluşturarak tekrar oluşumu önüyoruz.",
  ],
  whyProfessional: [
    "Profesyonel ilaçlama daha etkili ve güvenli sonuçlar sunar.",
    "Doğru planlama sayesinde haşere oluşumu önlenir.",
    "Uygulama sonrası bekleme süresi profesyonelce yönetilir.",
    "Periyodik ilaçlama ile uzun vadeli koruma sağlanır.",
    "Yaşam ve çalışma alanlarınızın hijyeni korunur.",
  ],
  relatedServices: [
    { title: "Apartman Temizliği", path: "/hizmetlerimiz/apartman-temizligi" },
    { title: "Bina ve Site Temizliği", path: "/hizmetlerimiz/bina-ve-site-temizligi" },
    { title: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi" },
  ],
  faqs: [
    { question: "İlaçlama hizmeti hangi alanlarda yapılır?", answer: "Ev, apartman, site ve iş yerleri olmak üzere tüm yaşam ve çalışma alanlarında profesyonel ilaçlama hizmeti sunulur." },
    { question: "İlaçlama sonrası ne zaman yerleşilebilir?", answer: "Uygulanan ürüne ve alana göre değişir. Profesyonel ekibimiz size bekleme süresi ve havalandırma talimatlarını verir." },
    { question: "Periyodik ilaçlama yapılır mı?", answer: "Evet, haşere oluşumunu önlemek için periyodik ilaçlama planları oluşturulabilir." },
  ],
  ctaText: "Haşere ve böcek sorunları için profesyonel ilaçlama randevusu alın.",
  heroImage: "/assets/images/ilaclama.jpg",
};

export default function IlaclamaPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}